import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminTopLists from "@/pages/admin/AdminTopLists";

export const Route = createFileRoute("/admin/top-lists/")({
  component: () => (
    <ProtectedRoute>
      <AdminTopLists />
    </ProtectedRoute>
  ),
});
